module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n")
    ;  var u = require('util/TextUtil.js').default; 
    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\" asset-control\">\r\n    <div class=\"pf-control-core\" style=\"float:none;\">\r\n        <div class=\"asset-control-img\">\r\n            <img src=\"")
    ; __append( require('editor/icons/control_timer.png') )
    ; __append("\" />\r\n        </div>\r\n        <div>\r\n            <label>")
    ; __append(escapeFn( u.shortenLabel(name) ))
    ; __append("</label>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}